import {Cache} from "./Cache";

class Token extends Cache {
  constructor(session = false) {
    super(session);
    this.key += '_token';
  }
}

export const tokenCache = new Token();
